/**
 * These are the Informaticist permissions.
 */
// tslint:disable:variable-name
export const informaticistPermissions = {
  User: {
    Read: "caseCanRead",
    Write: "caseCanWrite",
    Delete: "caseCanDelete"
  },
  Manager: {
    Read: "caseCanRead",
    Write: "caseCanWrite",
    Delete: "caseCanDelete"
  }
};
